function stringToDateIso(dateString) {
  // state encapsulated and managed by the composable
  const value = dateString.trim();
  const parts = value.split('/');

  if (parts.length !== 3) return null;

  const day = parts[0].padStart(2, '0');
  const month = parts[1].padStart(2, '0');
  const year = parts[2];
  const isoStr = `${year}-${month}-${day}T00:00:00.000`;
  return new Date(isoStr);
}

function getYearDiffBetweenDates(dateInitial, dateFinal) {
  return Math.max((dateFinal.getFullYear() - dateInitial.getFullYear()), 0);
}

function isDateBetween(dateToCheck, startDate, endDate) {
  const date = dateToCheck.getTime();
  const start = startDate.getTime();
  const end = endDate.getTime();

  return date >= start && date <= end;
}

function isDateMayorThan(dateToCheck, date) {
  return dateToCheck.getTime() > date.getTime();
}

function toMadridUtcDate(dateStr, isStart) {
  // Convertimos la fecha como si fuera en la zona horaria de Madrid
  // y la pasamos a una fecha en UTC

  // Creamos una fecha local en Madrid
  const madridDateString = `${dateStr}T${isStart ? '00:00:00' : '23:59:59'}`;
  const madridDate = new Date(
    new Date(madridDateString).toLocaleString('en-US', {timeZone: 'Europe/Madrid'}),
  );

  // Devolvemos la fecha como UTC (el valor real que representa ese instante)
  return madridDate;
}

function getMadridTimeZoneAbbreviation(dateString) {
  const date = new Date(dateString);

  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Europe/Madrid',
    timeZoneName: 'short',
  });

  const parts = formatter.formatToParts(date);
  const tzName = parts.find((p) => p.type === 'timeZoneName');
  return tzName?.value || null;
}

function getMadridUtcOffsetHours(dateString) {
  const abbr = getMadridTimeZoneAbbreviation(dateString);
  if (abbr === 'GMT+1') return 1;
  if (abbr === 'GMT+2') return 2;
  return null; // desconocido o error
}

export default function() {
  return {
    stringToDateIso,
    getYearDiffBetweenDates,
    isDateBetween,
    isDateMayorThan,
    toMadridUtcDate,
    getMadridTimeZoneAbbreviation,
    getMadridUtcOffsetHours,
  };
}

